import React from 'react';
import { Box, Button } from '@mui/material';
import DataPointItem from './DataPointItem';
import useCustomizedDataEntrySectionsForTeacher from '../../../../hooks/useCustomizedDataEntrySectionsForTeacher';

const DataPointList = ({
  dataPoints,
  goalType,
  measurementUnit,
  trialsMax,
  promptingType,
  existingPromptingType,
  handleDeleteDataPoint,
  handleFieldChange,
  handleTrialChange,
  handleAddTrial,
  handleCriteriaChange,
  handlePromptingChange,
  handleCheckboxChange,
  handleAbcChange,
  handleTimeChange,
  goalPromptingLevel,
  prompting,
  allGoalData,
  user,
}) => {
  // Fetch custom data entry sections at the top level
  const { data: customSections = [], isLoading: isLoadingCustomSections } = useCustomizedDataEntrySectionsForTeacher(user?.schoolId);

  // Debug logs removed after verification
  return (
    <>
      {dataPoints?.map((dataPoint, index) => (
        <Box
          key={index}
          sx={{ borderBottom: '1px solid gray', pb: 2, position: 'relative' }}
        >
          {dataPoints.length > 1 && (
            <Button
              variant='contained'
              color='error'
              sx={{
                position: 'absolute',
                top: '0.5rem',
                right: '0.5rem',
                minWidth: 'auto',
                padding: '0.25rem 0.5rem',
                fontSize: '0.75rem',
              }}
              onClick={() => handleDeleteDataPoint(index)}
            >
              Delete
            </Button>
          )}

          <DataPointItem
            dataPoint={dataPoint}
            index={index}
            goalType={goalType}
            measurementUnit={measurementUnit}
            trialsMax={trialsMax}
            promptingType={promptingType}
            existingPromptingType={existingPromptingType}
            handleFieldChange={handleFieldChange}
            handleTrialChange={handleTrialChange}
            handleAddTrial={handleAddTrial}
            handleCriteriaChange={handleCriteriaChange}
            handlePromptingChange={handlePromptingChange}
            handleCheckboxChange={handleCheckboxChange}
            handleAbcChange={handleAbcChange}
            handleTimeChange={handleTimeChange}
            goalPromptingLevel={goalPromptingLevel}
            prompting={prompting}
            allGoalData={allGoalData}
            user={user}
            customSections={customSections}
            isLoadingCustomSections={isLoadingCustomSections}
          />
        </Box>
      ))}
    </>
  );
};

export default DataPointList;
